import type { FunctionComponent } from "react";

import MascotPang from "./mascot-pang.png";
import { Container, MascotPangContainer, StyledImg } from "./styles";

export const BottomBackground: FunctionComponent = () => (
  <Container>
    <MascotPangContainer>
      <StyledImg alt={MascotPang.alt} src={MascotPang.src} />
    </MascotPangContainer>
  </Container>
);

BottomBackground.displayName = "BottomBackground";
